module.exports = __webpack_public_path__ + "static/media/blueSoap.849b5d73.jpg";